import React, { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCheckout } from "@/hooks/useCheckout";

export default function StickyOrderBar({ product }) {
    const { openCheckout, isOpen } = useCheckout();
    const [scrolled, setScrolled] = useState(false);
    const [checkoutVisible, setCheckoutVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 450);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const el = document.getElementById("checkout");
        if (!el || !("IntersectionObserver" in window)) return;
        const io = new IntersectionObserver(([e]) => setCheckoutVisible(e.isIntersecting), { threshold: 0.05 });
        io.observe(el);
        return () => io.disconnect();
    }, [product]);

    const price = product?.bundles?.[0]?.price;
    if (!product || !price) return null;
    const show = scrolled && !checkoutVisible && !isOpen;

    return (
        <>
            <div className="h-20 sm:hidden" aria-hidden="true" />
            <div
                data-testid="sticky-order-bar"
                aria-hidden={!show}
                className={`sm:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 bg-cream/90 backdrop-blur-md border-t border-forest-100 shadow-[0_-8px_24px_rgba(22,55,33,0.12)] transition-[transform,opacity] duration-300 ${show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"}`}
            >
                <button
                    type="button"
                    data-testid="sticky-order-btn"
                    onClick={openCheckout}
                    tabIndex={show ? 0 : -1}
                    className="w-full flex items-center justify-center gap-2.5 bg-forest-800 active:scale-[0.98] text-gold-400 font-bold text-base py-3.5 rounded-2xl border-2 border-gold-500 shadow-lg transition-transform"
                >
                    <ShoppingBag className="w-5 h-5" />
                    Order Now · {price.toLocaleString()} PKR
                </button>
            </div>
        </>
    );
}
